import { Check, MapPin, Users, Clock, Calendar, Sparkles } from "lucide-react";

/**
 * Standardised info-strip near the top of every program landing page.
 * Answers the most common parent questions at a glance.
 */
export default function ProgramInfoBlocks({ program }) {
  if (!program) return null;
  const trialAvailable = program.program_type !== "waitlist";
  const items = [
    {
      icon: Users,
      label: "Recommended ages",
      value: program.age_range || program.ages || "All ages",
    },
    {
      icon: Sparkles,
      label: "Category",
      value: program.category || "Program",
    },
    {
      icon: Check,
      label: "Trial class",
      value: trialAvailable ? "Available" : "Coming soon",
      isPositive: trialAvailable,
    },
    {
      icon: Check,
      label: "Experience level",
      value: program.beginner_friendly !== false ? "Beginner friendly" : "Intermediate +",
      isPositive: true,
    },
    {
      icon: MapPin,
      label: "Location",
      value: "Richmond BC",
    },
    {
      icon: Users,
      label: "Group size",
      value: "Small groups",
    },
  ];
  if (program.class_length || program.duration) {
    items.push({
      icon: Clock,
      label: "Class length",
      value: program.class_length || program.duration,
    });
  }
  if (program.bookwhen_url) {
    items.push({
      icon: Calendar,
      label: "Schedule",
      value: "View live",
      href: program.bookwhen_url,
    });
  }

  return (
    <section
      className="border-y border-slate-200/70 bg-white"
      data-testid="program-info-blocks"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {items.map((it) => {
          const Icon = it.icon;
          const content = (
            <>
              <span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-sky-50 text-[#0369A1] shrink-0">
                <Icon className="h-5 w-5" />
              </span>
              <div className="min-w-0">
                <p className="text-[11px] uppercase tracking-wider text-slate-500 font-bold">
                  {it.label}
                </p>
                <p
                  className={`font-display font-bold mt-0.5 text-sm ${
                    it.isPositive === false
                      ? "text-slate-500"
                      : "text-slate-900"
                  }`}
                >
                  {it.value}
                </p>
              </div>
            </>
          );
          if (it.href) {
            return (
              <a
                key={it.label}
                href={it.href}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-start gap-3 hover:opacity-80 transition-opacity"
                data-testid={`info-block-${it.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              >
                {content}
              </a>
            );
          }
          return (
            <div
              key={it.label}
              className="flex items-start gap-3"
              data-testid={`info-block-${it.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            >
              {content}
            </div>
          );
        })}
      </div>
    </section>
  );
}
